<template>
  <CModal
    v-model:visible="showModal"
    centered
    title="Set User Subscription"
    @close="closeModal"
  >
    <CCardBody class="pt-0">
      <CSelect
        :value="type"
        :options="statuses"
        label="Subscription"
        @update:value="updateData($event)"
      />
      <div
        v-if="set_date"
        class="d-flex justify-content-center"
      >
        <vc-date-picker
          v-model="expire_at"
          mode="dateTime"
          :is24hr="is24Hour"
          :min-date="new Date()"
        />
      </div>
      <div class="d-flex mt-3 align-items-center justify-content-center">
        <CButton
          color="secondary"
          class="mx-auto text-uppercase"
          @click="showModal = false"
        >
          Cancel
        </CButton>
        <CButton
          color="primary"
          class="mx-auto text-uppercase btn_yes"
          @click="save()"
        >
          Set
        </CButton>
      </div>
    </CCardBody>
    <template #footer-wrapper>
      <div class="d-flex my-0 align-items-center justify-content-center" />
    </template>
  </CModal>
</template>

<script>
export default {
  name: "AdminSubscriptionModal",
  data() {
    return {
      user: null,
      type: 0,
      showModal: false,
      loading: true,
      statuses: [
        {value: 0, label: 'None'},
        {value: 1, label: 'Basic'},
        {value: 2, label: 'Plus'},
        {value: 3, label: 'Connect'},
      ],
      expire_at: new Date(),
      expire_at_min: new Date(),
      set_date: false,
    }
  },
  computed: {},
  methods: {
    updateData(val) {
      this.type = val;
      this.set_date = !!val;
      if (!val) {
        this.expire_at = null;
      }
      if(val && !this.expire_at){
        this.expire_at = new Date();
      }
    },
    open(user) {
      this.showModal = true;
      this.user = Object.assign({}, user);
      this.expire_at = this.user.admin_subscription_expire_at
        ? this.$moment.utc(this.user.admin_subscription_expire_at).local().toDate()
        : null;
      this.type = this.user.admin_subscription_type;
      this.set_date = !!this.type;
    },
    closeModal() {
      this.$emit('modal:close');
      document.querySelector('body').classList.remove('modal_open')
    },
    save() {
        const expire_at_utc = this.expire_at
          ? this.$moment(this.expire_at).utc().format("YYYY-MM-DD HH:mm:ss")
          : null;

        this.$http.put(`/users/${this.user.id}/admin_subscription`, {
          type: this.type,
          expire_at: expire_at_utc
        })
        .then(() => {
          this.$toast.success("Updated!");
          this.$emit("updated");
        })
        .catch(() => {
          this.$toast.error("Oops, something went wrong!");
        })
        .finally(() => {
          this.showModal = false;
          this.closeModal();
        });
    }
  }
}
</script>

<style scoped>
</style>
